module.exports = __webpack_public_path__ + "static/selfie-cdb5b0568b18b498c15589aceabbba37.jpg";